//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './TransactionsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type TransactionsGetListTransactionsQueryParameters = {
  portfolioId?: string | undefined ;
  type?: Types.TransactionType | undefined ;
  status?: Types.TransactionStatus | undefined ;
  minDate?: string | undefined ;
  maxDate?: string | undefined ;
  minAmount?: number | undefined ;
  maxAmount?: number | undefined ;
  sorting?: string | undefined ;
  skipCount?: number | undefined ;
  maxResultCount?: number | undefined ;
}

export type TransactionsGetTransactionsQueryParameters = {
  id: string ;
}

export type TransactionsDeleteTransactionsQueryParameters = {
  id: string ;
}

export type TransactionsApproveTransactionsQueryParameters = {
  id: string ;
}

export function transactionsGetListUrl(portfolioId?: string | undefined, type?: Types.TransactionType | undefined, status?: Types.TransactionStatus | undefined, minDate?: string | undefined, maxDate?: string | undefined, minAmount?: number | undefined, maxAmount?: number | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/transactions?";
if (portfolioId === null)
    throw new Error("The parameter 'portfolioId' cannot be null.");
else if (portfolioId !== undefined)
    url_ += "PortfolioId=" + encodeURIComponent("" + portfolioId) + "&";
if (type === null)
    throw new Error("The parameter 'type' cannot be null.");
else if (type !== undefined)
    url_ += "Type=" + encodeURIComponent("" + type) + "&";
if (status === null)
    throw new Error("The parameter 'status' cannot be null.");
else if (status !== undefined)
    url_ += "Status=" + encodeURIComponent("" + status) + "&";
if (minDate === null)
    throw new Error("The parameter 'minDate' cannot be null.");
else if (minDate !== undefined)
    url_ += "MinDate=" + encodeURIComponent("" + minDate) + "&";
if (maxDate === null)
    throw new Error("The parameter 'maxDate' cannot be null.");
else if (maxDate !== undefined)
    url_ += "MaxDate=" + encodeURIComponent("" + maxDate) + "&";
if (minAmount === null)
    throw new Error("The parameter 'minAmount' cannot be null.");
else if (minAmount !== undefined)
    url_ += "MinAmount=" + encodeURIComponent("" + minAmount) + "&";
if (maxAmount === null)
    throw new Error("The parameter 'maxAmount' cannot be null.");
else if (maxAmount !== undefined)
    url_ += "MaxAmount=" + encodeURIComponent("" + maxAmount) + "&";
if (sorting === null)
    throw new Error("The parameter 'sorting' cannot be null.");
else if (sorting !== undefined)
    url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
if (skipCount === null)
    throw new Error("The parameter 'skipCount' cannot be null.");
else if (skipCount !== undefined)
    url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
if (maxResultCount === null)
    throw new Error("The parameter 'maxResultCount' cannot be null.");
else if (maxResultCount !== undefined)
    url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let transactionsGetListDefaultOptions: Omit<UseQueryOptions<Types.PagedResultDtoOfTransactionDto, unknown, Types.PagedResultDtoOfTransactionDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultDtoOfTransactionDto, unknown, Types.PagedResultDtoOfTransactionDto>, 'queryFn'>> = {
};
export function getTransactionsGetListDefaultOptions() {
  return transactionsGetListDefaultOptions;
};
export function setTransactionsGetListDefaultOptions(options: typeof transactionsGetListDefaultOptions) {
  transactionsGetListDefaultOptions = options;
}

export function transactionsGetListQueryKey(dto: TransactionsGetListTransactionsQueryParameters): QueryKey;
export function transactionsGetListQueryKey(portfolioId?: string | undefined, type?: Types.TransactionType | undefined, status?: Types.TransactionStatus | undefined, minDate?: string | undefined, maxDate?: string | undefined, minAmount?: number | undefined, maxAmount?: number | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): QueryKey;
export function transactionsGetListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { portfolioId, type, status, minDate, maxDate, minAmount, maxAmount, sorting, skipCount, maxResultCount,  } = params[0] as TransactionsGetListTransactionsQueryParameters;

    return trimArrayEnd([
        'TransactionsClient',
        'transactionsGetList',
        portfolioId as any,
        type as any,
        status as any,
        minDate as any,
        maxDate as any,
        minAmount as any,
        maxAmount as any,
        sorting as any,
        skipCount as any,
        maxResultCount as any,
      ]);
  } else {
    return trimArrayEnd([
        'TransactionsClient',
        'transactionsGetList',
        ...params
      ]);
  }
}
export function __transactionsGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.transactionsGetList(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as Types.TransactionType | undefined,       context.queryKey[4] as Types.TransactionStatus | undefined,       context.queryKey[5] as string | undefined,       context.queryKey[6] as string | undefined,       context.queryKey[7] as number | undefined,       context.queryKey[8] as number | undefined,       context.queryKey[9] as string | undefined,       context.queryKey[10] as number | undefined,       context.queryKey[11] as number | undefined,axiosConfig    );
}

export function useTransactionsGetListQuery<TSelectData = Types.PagedResultDtoOfTransactionDto, TError = unknown>(dto: TransactionsGetListTransactionsQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfTransactionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param portfolioId (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param minDate (optional) 
 * @param maxDate (optional) 
 * @param minAmount (optional) 
 * @param maxAmount (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function useTransactionsGetListQuery<TSelectData = Types.PagedResultDtoOfTransactionDto, TError = unknown>(portfolioId?: string | undefined, type?: Types.TransactionType | undefined, status?: Types.TransactionStatus | undefined, minDate?: string | undefined, maxDate?: string | undefined, minAmount?: number | undefined, maxAmount?: number | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfTransactionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useTransactionsGetListQuery<TSelectData = Types.PagedResultDtoOfTransactionDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultDtoOfTransactionDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let portfolioId: any = undefined;
  let type: any = undefined;
  let status: any = undefined;
  let minDate: any = undefined;
  let maxDate: any = undefined;
  let minAmount: any = undefined;
  let maxAmount: any = undefined;
  let sorting: any = undefined;
  let skipCount: any = undefined;
  let maxResultCount: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ portfolioId, type, status, minDate, maxDate, minAmount, maxAmount, sorting, skipCount, maxResultCount,  } = params[0] as TransactionsGetListTransactionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [portfolioId, type, status, minDate, maxDate, minAmount, maxAmount, sorting, skipCount, maxResultCount, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultDtoOfTransactionDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __transactionsGetList(context, axiosConfig) : __transactionsGetList,
    queryKey: transactionsGetListQueryKey(portfolioId, type, status, minDate, maxDate, minAmount, maxAmount, sorting, skipCount, maxResultCount),
    ...transactionsGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultDtoOfTransactionDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param portfolioId (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param minDate (optional) 
 * @param maxDate (optional) 
 * @param minAmount (optional) 
 * @param maxAmount (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setTransactionsGetListData(queryClient: QueryClient, updater: (data: Types.PagedResultDtoOfTransactionDto | undefined) => Types.PagedResultDtoOfTransactionDto, portfolioId?: string | undefined, type?: Types.TransactionType | undefined, status?: Types.TransactionStatus | undefined, minDate?: string | undefined, maxDate?: string | undefined, minAmount?: number | undefined, maxAmount?: number | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined) {
  queryClient.setQueryData(transactionsGetListQueryKey(portfolioId, type, status, minDate, maxDate, minAmount, maxAmount, sorting, skipCount, maxResultCount),
    updater
  );
}

/**
 * @param portfolioId (optional) 
 * @param type (optional) 
 * @param status (optional) 
 * @param minDate (optional) 
 * @param maxDate (optional) 
 * @param minAmount (optional) 
 * @param maxAmount (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setTransactionsGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultDtoOfTransactionDto | undefined) => Types.PagedResultDtoOfTransactionDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function transactionsCreateUrl(): string {
  let url_ = getBaseUrl() + "/api/transactions";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function transactionsCreateMutationKey(): MutationKey {
  return trimArrayEnd([
      'TransactionsClient',
      'transactionsCreate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useTransactionsCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.TransactionDto, unknown, Types.TransactionCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TransactionDto, unknown, Types.TransactionCreateDto, TContext> {
  const key = transactionsCreateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.TransactionCreateDto) => Client.transactionsCreate(body),
    mutationKey: key,
  });
}
  
export function transactionsGetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/transactions/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let transactionsGetDefaultOptions: Omit<UseQueryOptions<Types.TransactionDto, unknown, Types.TransactionDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TransactionDto, unknown, Types.TransactionDto>, 'queryFn'>> = {
};
export function getTransactionsGetDefaultOptions() {
  return transactionsGetDefaultOptions;
};
export function setTransactionsGetDefaultOptions(options: typeof transactionsGetDefaultOptions) {
  transactionsGetDefaultOptions = options;
}

export function transactionsGetQueryKey(id: string): QueryKey;
export function transactionsGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as TransactionsGetTransactionsQueryParameters;

    return trimArrayEnd([
        'TransactionsClient',
        'transactionsGet',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'TransactionsClient',
        'transactionsGet',
        ...params
      ]);
  }
}
export function __transactionsGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.transactionsGet(
      context.queryKey[2] as string,axiosConfig    );
}

export function useTransactionsGetQuery<TSelectData = Types.TransactionDto, TError = unknown>(dto: TransactionsGetTransactionsQueryParameters, options?: Omit<UseQueryOptions<Types.TransactionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useTransactionsGetQuery<TSelectData = Types.TransactionDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.TransactionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useTransactionsGetQuery<TSelectData = Types.TransactionDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TransactionDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as TransactionsGetTransactionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TransactionDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __transactionsGet(context, axiosConfig) : __transactionsGet,
    queryKey: transactionsGetQueryKey(id),
    ...transactionsGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.TransactionDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setTransactionsGetData(queryClient: QueryClient, updater: (data: Types.TransactionDto | undefined) => Types.TransactionDto, id: string) {
  queryClient.setQueryData(transactionsGetQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setTransactionsGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TransactionDto | undefined) => Types.TransactionDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function transactionsDeleteUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/transactions/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function transactionsDeleteMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'TransactionsClient',
      'transactionsDelete',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useTransactionsDeleteMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = transactionsDeleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.transactionsDelete(id),
    mutationKey: key,
  });
}
  
type TransactionsDelete__MutationParameters = TransactionsDeleteTransactionsQueryParameters

/**
 * @return OK
 */
export function useTransactionsDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, TransactionsDelete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: TransactionsDeleteTransactionsQueryParameters}): UseMutationResult<void, unknown, TransactionsDelete__MutationParameters, TContext> {
  const key = transactionsDeleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: TransactionsDelete__MutationParameters) => Client.transactionsDelete(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function transactionsApproveUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/transactions/{id}/approve";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function transactionsApproveMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'TransactionsClient',
      'transactionsApprove',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useTransactionsApproveMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.TransactionDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TransactionDto, unknown, void, TContext> {
  const key = transactionsApproveMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.transactionsApprove(id),
    mutationKey: key,
  });
}
  
type TransactionsApprove__MutationParameters = TransactionsApproveTransactionsQueryParameters

/**
 * @return OK
 */
export function useTransactionsApproveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.TransactionDto, unknown, TransactionsApprove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: TransactionsApproveTransactionsQueryParameters}): UseMutationResult<Types.TransactionDto, unknown, TransactionsApprove__MutationParameters, TContext> {
  const key = transactionsApproveMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: TransactionsApprove__MutationParameters) => Client.transactionsApprove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}